import * as React from 'react';
import * as numeral from 'numeral';
import { orderBy, uniqBy } from 'lodash';
import { Seat, CartSeat, SeatZone, SeatPricing } from '../../classes/seat';

import { PriceType } from '../../classes/price-type';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { IApplicationModel } from '../../reducers/app-reducer';
import { getCurrencyFormat } from '../../helpers/currency-format';
import { ItemType } from '../../classes/item-type';
import { Html } from '../../helpers/html-helpers';
import { sortPriceTypes } from '../../helpers/price-type-helpers';

interface ISeatHoverProps {
    xPosition: number;
    yPosition: number;
    seats: Array<Seat>;
    cartSeats: Array<CartSeat>;
    levelPricing: Array<SeatZone>;
    selectedPriceTypes: Array<PriceType>;
    appSettingsModel: IAppSettingsModel;
    showHover: boolean;
    dispatch: any;
    isChrome: boolean;
}

interface ISeatHoverState {
}

class SeatHover extends React.PureComponent<ISeatHoverProps, ISeatHoverState>{
    constructor(props) {
        super(props);
    }

    hoverBoxClassName = 'seat-tooltip';

    getSelectedPrices(props: ISeatHoverProps) {
        // If no seats, no prices
        if (props.seats.length === 0 || props.seats.every(s => !s.tessituraSeat.isAvailable)) {
            return [];
        }

        // Get the prices for this zone
        const zonePrices = props.levelPricing.filter(pricing => pricing.zoneId.toString() === props.seats[0].tessituraSeat.zoneId);
        if (zonePrices.length < 1) {
            return [];
        }

        var sortedPriceTypes = sortPriceTypes(props.selectedPriceTypes);
        // Get the id's of the selected price types
        const selectedPriceTypeIds = sortedPriceTypes.map(pt => pt.priceTypeId);

        if (selectedPriceTypeIds.length === 0) {
            return zonePrices[0].prices;
        }

        // Get the unique prices from the zone that are also selected
        return orderBy(uniqBy(zonePrices[0].prices
            .filter(price => selectedPriceTypeIds.indexOf(price.priceTypeId) >= 0),
            price => price.priceTypeId),
            pr => selectedPriceTypeIds.indexOf(pr.priceTypeId)
        );
    }

    getSeatsRemainingText(): string {
        const seatsRemaining = this.props.seats.filter(seat => seat.tessituraSeat.isAvailable).length;

        return this.fetchHoverText(seatsRemaining, this.props.appSettingsModel.seatsRemainingText);
    }

    fetchHoverText(response, seatsAvailableText) {
        return seatsAvailableText.replace("{0}", response.toString());
    }

    render() {
        var selectedPrices = this.getSelectedPrices(this.props);
        var mapRect = null;
        var mapSVGRect = null;
        if (this.props.showHover) {
            mapRect = document.getElementById('mapContainer').getBoundingClientRect();
            mapSVGRect = document.getElementById('mapSvg').getBoundingClientRect();
        }

        let section = this.props.seats.length > 0 ? this.props.appSettingsModel.useZoneDescription && this.props.seats[0].zoneDescription !== null ? this.props.seats[0].zoneDescription : this.props.seats[0].tessituraSeat.sectionDescription : '';
        return (
            <foreignObject style={{ position: 'absolute' }}
                x={0}
                y={0}
                width="260" height="220" id="seat-tooltip-fo">
                <div
                    className={this.hoverBoxClassName
                        + (this.props.isChrome ? ' tooltip-chrome' : '')
                        + (this.props.yPosition <= window.innerHeight / 2 ? ' tooltip-up' : ' tooltip-down')
                        + (this.props.showHover ? ' tooltip-show' : ' tooltip-hide')}>
                    <div className="seat-tooltip-header">
                        <div className="seat-tooltip-header-section">
                            {
                                this.props.seats.length > 0 ?
                                    <span>{this.props.seats.length > 1 ? this.props.appSettingsModel.groupSeatCartItemText.replace("{0}", "").replace("{1}", section)
                                        : `${section}`}
                                    </span>
                                    : null
                            }
                        </div>
                        <div className="seat-tooltip-header-seat">
                            <span>{this.props.seats.length > 1 ? this.props.appSettingsModel.groupSeatCartItemText.replace("{0}", "").replace("{1}", section)
                                : `${this.props.seats[0].tessituraSeat.rowText}-${this.props.seats[0].tessituraSeat.numberText}`}
                            </span>

                        </div>
                    </div>

                    {
                        selectedPrices.length > 0 ?
                            <div className="seat-tooltip-prices">
                                <div className="seat-tooltip-prices-list">
                                    {selectedPrices.length === 1 ?
                                        <span className="seat-tooltip-prices-list-text">
                                            {this.props.appSettingsModel.itemType === ItemType.Exchange && selectedPrices[0].price === 0
                                                && this.props.appSettingsModel.exchangeFreeLabel.length > 0 ?
                                                this.props.appSettingsModel.exchangeFreeLabel
                                                : getCurrencyFormat(this.props.appSettingsModel.currencyFormat, selectedPrices[0].price)} - {selectedPrices[0].priceTypeDescription}</span>
                                        :
                                        orderBy(selectedPrices, selectedPrice => selectedPrice.price).map(price => {
                                            return <div key={price.priceTypeId} className="seat-tooltip-prices-list-item">
                                                <span className="seat-tooltip-prices-list-text">{getCurrencyFormat(this.props.appSettingsModel.currencyFormat, price.price)} - {price.priceTypeDescription}</span>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        this.props.seats.length > 0 ?
                            <div>

                                {
                                    this.props.appSettingsModel.seatHoverMessageText !== null && this.props.appSettingsModel.seatHoverMessageText.substr(0, 4) === "<div" ?
                                        <div className="seat-tooltip-options">
                                            <div className="rich-text seat-info-options-copy" dangerouslySetInnerHTML={{ __html: this.props.appSettingsModel.seatHoverMessageText }}></div>
                                        </div>
                                        :
                                        this.props.appSettingsModel.seatHoverMessageText !== null ?
                                            <div className="seat-tooltip-options">
                                                <div className="seat-tooltip-options-copy">
                                                    {this.props.appSettingsModel.seatHoverMessageText}
                                                </div>
                                            </div>
                                            : null
                                }
                                {
                                    this.props.seats[0].tessituraSeat.isDisabled && this.props.seats[0].seatingOptionGroup !== null && this.props.seats[0].seatingOptionGroup.unlockSeatingOptionGroupId != null ?
                                        <div className="seat-tooltip-options">
                                            <div className="seat-tooltip-options-copy">
                                                {this.props.seats[0].seatingOptionGroup.addSeatsToUnlockMessage}
                                            </div>
                                        </div>
                                        :
                                        this.props.seats[0].seatStyleCulture.smallPrompt !== null && this.props.seats[0].seatStyleCulture.smallPrompt.substr(0, 4) === "<div" ?
                                            <div className="seat-tooltip-options">
                                                <div className="rich-text seat-info-options-copy" dangerouslySetInnerHTML={{ __html: this.props.seats[0].seatStyleCulture.smallPrompt }}></div>
                                            </div>
                                            :
                                            this.props.seats[0].seatStyleCulture.smallPrompt !== null ?
                                                <div className="seat-tooltip-options">
                                                    <div className="seat-tooltip-options-copy">
                                                        {this.props.seats[0].seatStyleCulture.smallPrompt}
                                                    </div>
                                                </div>
                                                : null
                                }
                            </div>
                            :
                            null
                    }
                    {
                        (this.props.seats.length > 1) && Html.renderDiv(this.getSeatsRemainingText(), 'seat-tooltip-remaining')
                    }

                    {
                        (selectedPrices.length == 0) && Html.renderDiv(this.props.appSettingsModel.seatHoverMissingPriceTypesMessage, 'seat-tooltip-remaining')
                    }

                </div>
            </foreignObject>
        );
    }

    componentDidMount() {
        var hoverBox = document.getElementsByClassName(this.hoverBoxClassName)[0];
        var height = hoverBox.getBoundingClientRect().height;
        var hoverFO = document.getElementsByTagName('foreignObject')[0];
        hoverFO.setAttribute('height', height.toString());

        var hoverViewBox = document.getElementsByClassName('hover-map-svg')[0];
        hoverViewBox.setAttribute('viewBox', `0 0 260 ${height}`);

    }

}

export default SeatHover;